import { useCounter } from '@/hooks/useCounter';

interface StatProps { end: number; suffix: string; label: string; sub: string; delay: number; }

function Stat({ end, suffix, label, sub, delay }: StatProps) {
  const { count, ref } = useCounter(end, 2400);
  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className="reveal"
      style={{ transitionDelay: `${delay}s` }}
    >
      <div className="text-gradient-white h-font" style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(48px, 6vw, 72px)', lineHeight: 1 }}>
        {count}<span style={{ WebkitTextFillColor: 'var(--orange)' }}>{suffix}</span>
      </div>
      <div style={{ fontWeight: 700, fontSize: 15, color: 'var(--text1)', marginTop: 8 }}>{label}</div>
      <div style={{ fontSize: 13, color: 'var(--text3)', marginTop: 4, maxWidth: 200 }}>{sub}</div>
    </div>
  );
}

export default function StatsSection() {
  return (
    <section
      className="relative overflow-hidden"
      style={{ background: 'var(--bg)', padding: '100px 0', borderTop: '1px solid var(--border)' }}
    >
      <div className="absolute inset-0 pointer-events-none">
        <div style={{ position: 'absolute', top: '50%', left: '50%', width: 700, height: 700, transform: 'translate(-50%,-50%)', background: 'radial-gradient(circle, rgba(232,97,26,0.06) 0%, transparent 60%)', borderRadius: '50%' }}></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-16">
          <div>
            <div className="label"><div className="label-dot"></div>Rakamlarla CargoNet</div>
            <h2
              className="reveal h-font"
              style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(36px, 4.5vw, 56px)', color: 'var(--text1)', lineHeight: 1.1 }}
            >
              Her rakamın arkasında<br />
              <span className="text-gradient">bir başarı hikayesi.</span>
            </h2>
          </div>
          <p className="reveal d2 text-base leading-relaxed" style={{ color: 'var(--text2)', maxWidth: 440 }}>
            2010&apos;dan bu yana büyüyen lojistik ağımız, her yıl binlerce müşteriye ve
            milyonlarca ürüne güvenli ulaşım sağlıyor.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div className="grid grid-cols-2 gap-8 lg:gap-12">
            <Stat end={30} suffix="+" label="Ülkeye Teslimat" sub="Avrupa, Orta Doğu, Amerika" delay={0} />
            <Stat end={8400} suffix="+" label="Aylık Gönderi" sub="Ekspres ve standart kargo" delay={0.1} />
            <Stat end={4600} suffix="+" label="Fulfillment Dağıtım" sub="Aylık sipariş karşılama" delay={0.2} />
            <Stat end={99} suffix=".8%" label="Başarı Oranı" sub="Zamanında teslimat garantisi" delay={0.3} />
          </div>

          <div className="reveal-r">
            <div
              className="relative rounded-3xl overflow-hidden grad-border"
              style={{ aspectRatio: '4/3' }}
            >
              <img
                src="https://readdy.ai/api/search-image?query=3d%20render%20of%20glowing%20world%20map%20network%20with%20orange%20connection%20lines%20between%20cities%20package%20delivery%20nodes%20dark%20space%20background%20futuristic%20global%20logistics%20visualization%20professional%203d%20art&width=700&height=530&seq=stats3d&orientation=landscape"
                alt="Global Network"
                className="w-full h-full object-cover"
              />
              <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(135deg, var(--overlay-strong) 0%, transparent 60%)' }}></div>

              <div
                className="glass absolute bottom-6 left-6 px-5 py-4 rounded-2xl float-y"
                style={{ boxShadow: '0 8px 40px rgba(0,0,0,0.3)' }}
              >
                <div style={{ fontSize: 11, color: 'var(--text3)', marginBottom: 2 }}>Aktif Partner Ülkeler</div>
                <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 32, color: 'var(--text1)', lineHeight: 1 }}>
                  24<span style={{ color: 'var(--orange)' }}>+</span>
                </div>
                <div className="flex items-center gap-1 mt-2">
                  {['🇩🇪','🇺🇸','🇳🇱','🇦🇪','🇫🇷'].map((f, i) => (
                    <span key={i} style={{ fontSize: 16 }}>{f}</span>
                  ))}
                  <span style={{ fontSize: 12, color: 'var(--text3)', marginLeft: 4 }}>+19</span>
                </div>
              </div>

              <div className="glass absolute top-6 right-6 px-4 py-2.5 rounded-xl">
                <div className="flex items-center gap-2">
                  <span className="w-2 h-2 rounded-full bg-green-500 inline-block animate-pulse"></span>
                  <span style={{ fontSize: 13, fontWeight: 700, color: 'var(--text1)' }}>7/24 Aktif</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
